/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, September 11th 2022, 2:42:31 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { DnDItemTypes } from "config";
import { NODE_TYPES } from "lib/schemas";
import { CustomDragLayer, useOSCustomDragLayer } from "ui-widgets/drag-and-drop";
import { ToolBarItemDragLayer } from "common/components/toolbar";
import { BPMNDraggableNodeTypeIcon } from "./BPMNDraggableNodeTypeButton";
import { INodeTypeDnDSelectorState } from "./types";

export const BPMNNodeTypeDragLayer = React.memo(() => {
  const { collectedProps } = useOSCustomDragLayer<INodeTypeDnDSelectorState>({
    itemType: DnDItemTypes.OS_ADD_NEW_TASK_TEMPLATE,
  });

  const newNodeType = collectedProps?.item?.newNodeType;

  return newNodeType ? (
    <CustomDragLayer collectedProps={collectedProps as any}>
      <ToolBarItemDragLayer
        buttonIcon={<BPMNDraggableNodeTypeIcon taskType={newNodeType} />}
        buttonTitle={NODE_TYPES[newNodeType]}
      />
    </CustomDragLayer>
  ) : null;
});
